// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tlm-product-info__title{min-height:28px}@media screen and (min-width:960px){.tlm-product-info__item:first-child:not(:last-child){padding-right:2.77775%}.tlm-product-info__item:nth-child(2){padding-left:2.77775%}.tlm-product-info__item:first-child:last-child{margin:0 auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
